import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';

declare var google;
@Component({
  selector: 'adf-liablities-form',
  templateUrl: 'liablities.html',
  providers: [EnvDataService]
})
export class LiablitiesForm {
  @Input() editdata: any;
  @Output() liabilityFormData_evtemit = new EventEmitter();
  @Output() checkbalance_evtemit=new EventEmitter();
  callMethod() {
  }

  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2,
    suffix: ' '
  })

  liabilitiesForm: FormGroup;

  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  public change_log_string: any;
  public indexx: number;
  public percentage_0: any;
  public percentage_1: any;
  public percentage_2: any;
  public percentage_3: any;
  public percentage_4: any;
  public percentage_5: any;
  public allLiabilitiess: any;
  public liability_details: any;
  public currentBalanceCheck:boolean=false;

  public validation_messages = {
    'amount': [
      { type: 'required', message: 'This field is required.' }
    ],
    'frequency': [
      { type: 'required', message: 'This field is required.' }
    ],
    'date_commenced': [
      { type: 'required', message: 'This field is required.' }
    ],
    'liability_type': [
      { type: 'required', message: 'This field is required.' }
    ],
    'current_balance': [
      { type: 'required', message: 'This field is required.' }
    ],
    'limit': [
      { type: 'required', message: 'This field is required.' }
    ]

  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public alertCtrl: AlertController,
    public SdfFormService: SdfFormService,
    private storage: AngularFireStorage,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];
    this.allLiabilitiess = [];
    this.liability_details = [];

    this.liabilitiesForm = formBuilder.group({
      firstname: [''],
      lastname: [''],
      uid:[''],
      primaryowner: [''],
      itemRowsLiabilities: formBuilder.array([]),
      addAnotherApplicantItem: this.formBuilder.array([])
    });


  }
  initItemRowsLiabilities() {
    return this.formBuilder.group({
    
      liability_type: ['Commercial Bill', Validators.compose([Validators.required])],
      current_balance: ['', Validators.compose([Validators.required])],
      limit: ['', Validators.compose([Validators.required])],
      credit_cart_type: [''],
      institution: [''],
      account_name: [''],
      bsb: [''],
      account_no: [''],
      clearing_from_this_loan: [''],
      owner: [''],
      repayments: [''],
      payment_type: [''],
      description: [''],
      document_id: [''],

      deleted: [0]
    });
  }

  initItemRowsLiabilities2(formObj) {
    return this.formBuilder.group({
     
      liability_type: [formObj.liability_type, Validators.compose([Validators.required])],
      current_balance: [formObj.current_balance, Validators.compose([Validators.required])],
      limit: [formObj.limit, Validators.compose([Validators.required])],
      credit_cart_type: [formObj.credit_cart_type],
      institution: [formObj.institution],
      account_name: [formObj.account_name],
      bsb: [formObj.bsb],
      account_no: [formObj.account_no],
      clearing_from_this_loan: [formObj.clearing_from_this_loan],
      owner: [formObj.owner],
      repayments: [formObj.repayments],
      payment_type: [formObj.payment_type],
      description: [formObj.description],
      document_id: [formObj.document_id],
      deleted: [0]
    });
  }

  ngOnInit() {
  }


  ngOnChanges() {

  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }
  
  get formArrLiabilities() {
    return this.liabilitiesForm.get('itemRowsLiabilities') as FormArray;
  }



  changeLog(event, index: any) {

  }

  deleteRestoreDocument(index: number, document_id: any, type: any, collection: any, status: any, index1: number) {
    let alert = this.alertCtrl.create({
      title: 'Confirm ' + status + ' ' + type,
      message: 'Are you sure you want to ' + status + ' this ' + type + ' ?',
      buttons: [
        {
          text: 'No',
          handler: () => {
         
          }
        },
        {
          text: 'Yes',
          handler: () => {
            if (document_id != "") {
              let deleted = 0;
              if (status == 'delete') {
                deleted = 1;
              }
              let postData = {
                'document_id': document_id,
                'collection': collection,
                'deleted': deleted,
                'deleted_date': new Date().getTime()
              }
              this.SdfFormService.deleteDocument(postData);
              if (status == 'delete') {
                if (type == 'liability') {
                  this.formArrLiabilities.removeAt(index);
                }
              }
            } else {
              if (status == 'delete') {
                if (type == 'liability') {
                  this.formArrLiabilities.removeAt(index);
                }
              }
            }
          }
        }
      ]
    });
    alert.present();
  }

  addLiabilities() {

    let count:number=0;
    (<FormArray>this.liabilitiesForm.controls['itemRowsLiabilities']).controls.forEach(()=>{
      count++;
    })

    if(count == 0){
  
     
      this.formArrLiabilities.push(this.initItemRowsLiabilities());
      this.indexx = this.formArrLiabilities.controls.length - 1;
    }
    else{
  
      let check:boolean=false;
      this.liabilitiesForm.controls['itemRowsLiabilities']['controls'].forEach((element:FormGroup)=>{
        if(element.get('liability_type').value != '' 
        && element.get('current_balance').value != ''
        && element.get('limit').value != '' ){
          check=true
        }
        else{
          check=false;
        }
     
      })
     
      if(check){
        this.formArrLiabilities.push(this.initItemRowsLiabilities());
      }
      else{
       
      }
    }
  }

  getValue() {
   
    this.liabilityFormData_evtemit.emit({liabilityformvalue:this.liabilitiesForm.value,liabilitiesform:this.liabilitiesForm});
  }

  populateDataForEdit(data){
  

    if(data.length > 0)
    {
   
       let owner_index = 0;
      data.forEach((element,index)=>{
       
         if(!element.owner) {
            element.owner ='';
         }
        let z=this.initItemRowsLiabilities2(element);
    
        (<FormArray>this.liabilitiesForm.get('itemRowsLiabilities')).push(z);
      })
    }
    else
    {
   
    }
    this.checkEquality('edit',null);
  }

  public changeLiabilityType($event, index, type){
    let type_value = $event.target.value;
    var getRepayments = this.formArrLiabilities.at(index).get('repayments');
    if(type_value == 'Commercial Bill' || type_value == 'HECS' || type_value == 'Hire Purchase' || type_value == 'Maintenance' || type_value == 'Outstanding Taxation' || type_value == 'Other'){
      getRepayments.setValidators(null);
      getRepayments.updateValueAndValidity();
    }else{
      getRepayments.setValidators(Validators.required);
      getRepayments.updateValueAndValidity();
    }
   
    this.new_val = $event.target.value;
    this.old_val = '';
    var property = '';
    if(type == 'liability_type'){
      if(this.allLiabilitiess.length > index){
        this.old_val = this.allLiabilitiess[index].liability_type;
      }else{
        this.old_val = '';
      }
      if(this.old_val == undefined){
        this.old_val = '';
      }
      property = 'liability_type';
    }
    if(this.new_val != this.old_val){
      this.liability_details.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index' : index});
    }
    this.liability_details.sort((a,b)=>a.index > b.index);
  }

  setLiabilitiesform(liabilityformvalue) {
  
    if(liabilityformvalue) {
      
      this.liabilitiesForm.controls.firstname.setValue(liabilityformvalue.firstname);
      this.liabilitiesForm.controls.lastname.setValue(liabilityformvalue.lastname);
     
      liabilityformvalue.addAnotherApplicantItem.forEach((item,index) => {
  
        if(this.formApplicant.value[index]) {
  
          this.formApplicant.value[index].secondary_firstname = item.secondary_firstname;
          this.formApplicant.value[index].secondary_lastname = item.secondary_lastname;
  
          }
          else {
  
               this.formApplicant.push(this.initaddAnotherApplicant(item,index));
  
          }
  
        
      });

      
    }
  }
  get formApplicant() {
    return this.liabilitiesForm.get('addAnotherApplicantItem') as FormArray;
  }

  addAnotherApplicant() {
   
  }

  initaddAnotherApplicant(item,index) {
    return this.formBuilder.group({
     
      secondary_firstname: [item.secondary_firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [item.secondary_middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [item.secondary_lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [item.secondary_email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [item.secondary_mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [item.secondary_date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: [item.relationship_to_primary_applicant, Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [index],
      user_type : ['secondary'],
      document_id: ['']
    });
  }
  initaddAnotherApplicant_one(item,index) {
    return this.formBuilder.group({
     
      secondary_firstname: [item.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [item.middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [item.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [item.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [item.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [item.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30)])],
      deleted: [0],
      uid: [index],
      user_type : ['secondary'],
      document_id: ['']
    });
  }
  initaddAnotherApplicant_1(item) {
    return this.formBuilder.group({
    
      secondary_firstname: [item.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [item.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [item.uid],
      user_type : ['primary'],
      document_id: ['']
    });
  }

  changeowner(event) {

    
 
  }

  checkEquality(event,index){
    const element=document.getElementById('check_balance_'+index);
    if(this.formArrLiabilities.length > 0 && index != null)
    {
      let currentValue=parseInt(this.formArrLiabilities['controls'][index].get('current_balance').value.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));
      let limitValue=parseInt(this.formArrLiabilities['controls'][index].get('limit').value.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, ''));


      if(limitValue !== NaN)
      {
        if((currentValue == limitValue) || (currentValue < limitValue))
        {
      
          element.style.display="none";
          this.checkbalance_evtemit.emit(true);
        }
        else{
 
          element.style.display="block";
          this.checkbalance_evtemit.emit(false);
        }
      }
    }
    if(event === 'edit'){
      this.checkbalance_evtemit.emit(true);
    }
  }
  setAdditionalDetails(data){
    console.log(data);
     data.forEach((element,index) => { 
         if(element.type == "additional") {
           if(this.formApplicant.value[index]) {
             this.formApplicant.value[index].secondary_firstname = element.user_data.firstname;
             this.formApplicant.value[index].secondary_lastname = element.user_data.lastname;
             }
             else {
               this.formApplicant.push(this.initaddAnotherApplicant_one(element.user_data,index));
             }
         }
         else {
          this.liabilitiesForm.controls.firstname.setValue(element.user_data.firstname);
          this.liabilitiesForm.controls.lastname.setValue(element.user_data.lastname);
         }
      
     });
     console.log(this.liabilitiesForm);
   }


}




// WEBPACK FOOTER //
// ./src/pages/adf-page/component/assets-and-liablities/liablities/liablities.ts